import axios from 'axios'

export default function setAuthToken(token, id, userType) { // userType : USER | EMPLOYEE
    console.log('================= setAuthToken ===================');
    console.log({token, id, userType});
    console.log('====================================');
    // axios.defaults.headers.common['Content-Type'] = `application/json`
    if(token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        axios.defaults.headers.common['UserType'] = userType
        axios.defaults.headers.common['UserID'] = id
        
    } else {
        delete axios.defaults.headers.common['Authorization']
        
    }
}